import React from 'react';
import PropTypes from 'prop-types';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { DragDropContext } from 'react-beautiful-dnd';
import { noop } from 'ui-components/default-props/noop';
import { useIsOnOrdersAdvancedSearchView } from '../../advanced-search/hooks';
import style from './orders-drawer.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  ordersDrawer: {
    description: 'The portion of the app that slides out like a drawer and displays sales order label configurations',
    defaultMessage: 'Orders Drawer',
    id: 'yDDs52',
  },
  noOrders: {
    description: 'orderDrawer.noOrders',
    defaultMessage: 'No Rows Selected',
    id: 'bTOi0F',
  },
  advancedSearchAllSelected: {
    description: 'orderDrawer.advancedSearch.allSelected',
    defaultMessage: 'To apply presets or update shipping configuration for your Advanced Search, use Bulk Update above',
    id: 'MPfle2',
  },
});

const OrdersGridDrawer = ({
  fulfillmentPlanIds = emptyArray,
  drawerSections = null,
  isLoading = false,
  onModuleReorder = noop,
  areAllOrdersSelected = false,
}) => {
  const intl = useIntl();

  const isOnAdvancedSearch = useIsOnOrdersAdvancedSearchView();
  if (isLoading) {
    return (
      <div className={style['loading-indicator-container']}>
        <LoadingIndicator className={style['loading-indicator']} />
      </div>
    );
  }

  if (isOnAdvancedSearch && areAllOrdersSelected) {
    return (
      <div className={style['no-orders']}>
        <FormattedMessage {...messages.advancedSearchAllSelected} />
      </div>
    );
  }

  if (fulfillmentPlanIds.length === 0 && !areAllOrdersSelected) {
    return (
      <div className={style['no-orders']}>
        <FormattedMessage {...messages.noOrders} />
      </div>
    );
  }

  const label = intl.formatMessage(messages.ordersDrawer);

  return (
    <div aria-label={label} className={style['orders-drawer']}>
      <DragDropContext onDragEnd={onModuleReorder}>{drawerSections}</DragDropContext>
    </div>
  );
};

OrdersGridDrawer.propTypes = {
  fulfillmentPlanIds: PropTypes.array,
  drawerSections: PropTypes.element,
  isLoading: PropTypes.bool,
  onModuleReorder: PropTypes.func,
  areAllOrdersSelected: PropTypes.bool,
};

export default OrdersGridDrawer;
